import fetchClient from '../utils/fetchClient';

export const getCatalogLevel = () => fetchClient.get('/catalog/level');
export const grantLikeXP = () => fetchClient.post('/catalog/xp/like');
export const getCatalogStats = () => fetchClient.get('/catalog/stats');
